//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      shareLinkList: [
        // {title: 'twitter', img: 'twitter', link: 'https://twitter.com/intent/tweet?url='},
        {title: 'vk', img: 'vk', link: 'https://vk.com/share.php?url='},
        {title: 'telegram', img: 'telegram', link: 'https://telegram.me/share/url?url='},
        {title: 'whatsapp', img: 'whatsapp', link: 'https://api.whatsapp.com/send/?text='},
        {title: 'ok', img: 'ok', link: 'https://connect.ok.ru/offer?url='},
      ],

      likeSection: {
        count: '0',
        isLike: false
      },
      commentSection: {
        count: '0'
      },
      shareSection: {}
    }
  },

  props: {
    // Настройки компонента "Нравится"
    like: {
      type: Object,
      default() {
        return {}
      }
    },
    scrollContainer: {
      type: String,
      default: '',
    },

    // Настройки компонента "Комментарии"
    comments: {
      type: Object,
      default() {
        return {}
      }
    },

    // Настройка компонента "Поделится"
    share: {
      type: Boolean,
      default: false
    }
  },

  async mounted() {
    if (Object.keys(this.like).length > 0) {
      await this.initLike()
    }

    if (Object.keys(this.comments).length > 0) {
      await this.initComment()
    }

    if (this.share) {
      await this.initShare()
    }
  },

  methods: {
    scrollToComments(comments) {
      this.$scrollTo(`#likeFromComm${comments?.model_key || ''}`, {
        container: `#${this.scrollContainer}`
      })
    },

    // Логика функционала лайка
    async initLike() {
      const {model, model_key} = this.like

      const {
        data: {count, is_liked}
      } = await this.$api.agent.transport.get(
        `likes/data/${model}/${model_key}`
      )

      const newLikeSection = {...this.likeSection}
      newLikeSection.count = count
      newLikeSection.isLike = is_liked

      this.likeSection = newLikeSection
    },
    async setLike() {
      const {model, model_key} = this.like
      const apiUrl = this.likeSection.isLike ? 'likes/dislike' : 'likes/like'
      const data = await this.$api.agent.transport.post(apiUrl, {
        model,
        model_key
      })

      await this.initLike()
    },

    // Логика функционала комментариев
    async initComment() {
      const {model, model_key} = this.comments
      const apiUrl = `reviews?filter[model]=${model}&filter[model_key]=${model_key}`

      const {headers} = await this.$api.transport.get(apiUrl)

      const newCommentSection = {...this.commentSection}
      newCommentSection.count = headers['x-pagination-total-count']

      this.commentSection = newCommentSection
    },

    // Логика функционала поделится
    async initShare() {
    },

    openShare(link) {
      window.open(`${link}${window.location.href}`)
    },

    async copyLink() {
      try {
        await this.$copyText(window.location.href);
        this.$toast.success('Ссылка скопирована');
      } catch (e) {
        this.$toast.success('Ошибка копирования');
      }
    },
  }
}
